<template>
  <j-page>
    <div slot="search" @keydown.enter="searchEvent">
      <j-page-search title="级联名称">
        <el-input v-model="query.cascadingTitle" placeholder="请输入级联名称" clearable/>
      </j-page-search>
      <j-page-search title="级联Key">
        <el-input v-model="query.cascadingKey" placeholder="请输入级联Key" clearable/>
      </j-page-search>
      <j-page-search title="创建时间">
        <j-date-range :start.sync="query.createTimeStart" :end.sync="query.createTimeEnd"/>
      </j-page-search>
      <el-button type="primary" icon="el-icon-search" @click="searchEvent">查询</el-button>
      <el-button type="info" icon="el-icon-refresh" @click="resetEvent">重置</el-button>
      <el-button type="warning" icon="el-icon-plus" @click="addDgmxEvent">新增</el-button>
      <el-button type="warning" plain icon="el-icon-refresh" @click="updateCache">更新缓存</el-button>
    </div>
    <div slot="table">
      <el-table v-loading="tableLoading" :data="tableData" height="100%">
        <el-table-column type="index" label="序号" align="center" width="50"/>
        <el-table-column prop="cascadingTitle" label="级联名称" align="center" show-overflow-tooltip/>
        <el-table-column prop="cascadingKey" label="级联Key" align="center" show-overflow-tooltip/>
        <el-table-column prop="note" label="备注" align="center" show-overflow-tooltip/>
        <el-table-column prop="createTime" label="创建时间" align="center" show-overflow-tooltip/>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button @click.stop="editDgmxEvent(scope.row)" type="text" class="common-button-edit">编辑</el-button>
            <el-button @click.stop="detailDgmxEvent(scope.row)" type="text" class="common-button-auth">配置级联节点
            </el-button>
            <el-button @click.stop="delEvent(scope.row)" type="text" class="common-button-del">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="pagination" v-show="query.total > 0">
      <el-pagination
          :current-page="query.page"
          :page-size="query.limit"
          :total="query.total"
          :background="pmxBackground"
          :pager-count="pmxCount"
          :layout="pmxLayout"
          :pageSizes="pmxSizes"
          @current-change="changePage"
          @size-change="sizeChange"
      />
    </div>

    <!--新增/编辑-->
    <el-dialog v-if="showDgmx" :title="dgmxTypeMap[dgmxType]" :visible.sync="showDgmx" width="450px" top="15vh"
               :close-on-click-modal="false">
      <el-form ref="dgmxDom" :model="dgmxForm" :rules="dgmxRule" :label-width="dgmxFormLabelWidth">
        <el-form-item label="级联名称" prop="cascadingTitle">
          <el-input v-model="dgmxForm.cascadingTitle" placeholder="请输入级联名称" maxlength="20" show-word-limit clearable/>
        </el-form-item>
        <el-form-item label="级联Key" prop="cascadingKey">
          <el-input v-model="dgmxForm.cascadingKey" placeholder="请输入级联Key" maxlength="20" show-word-limit clearable/>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input v-model="dgmxForm.note" type="textarea" :rows="3" placeholder="请输入备注" maxlength="200"
                    show-word-limit clearable/>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button type="primary" @click="checkDgmxEvent('saveDgmxData')" :loading="submitLoad">保存</el-button>
        <el-button type="info" @click="showDgmx = false">取消</el-button>
      </template>
    </el-dialog>

    <el-dialog custom-class="cascader-data-manage-config-dialog" v-if="showDgmxDetail" title="配置级联节点"
               :visible.sync="showDgmxDetail" width="800px" top="15vh" :close-on-click-modal="false">
      <div>
        <el-button type="primary" plain style="margin-bottom: 10px;" @click="appendRootNode">添加一级节点</el-button>
        <el-button type="primary" plain style="margin-bottom: 10px;" @click="showJson = true">添加JSON格式数据
        </el-button>
        <div class="cascader-data-manage-config-dialog-tree">
          <el-tree ref="tree" draggable :allow-drag="notEdit" :data="treeData" node-key="value" :expand-on-click-node="false">
            <div class="cascader-data-manage-config-tree-node" slot-scope="{ node, data }">
              <template v-if="data.edit">
                <div :id="`${data.label}-${data.value}-${data.edit}`" class="cascader-data-manage-config-tree-node-form">
                  <el-input class="cascader-data-manage-config-tree-node-input name" v-model="data.label"
                            @focus="() => data.error = ''"
                            placeholder="节点名称"/>
                  <el-input class="cascader-data-manage-config-tree-node-input" v-model="data.tempValue"
                            @focus="() => data.error = ''"
                            placeholder="节点标识"/>
                  <el-button type="text" @click.stop="() => saveNode(node, data)">确定</el-button>
                  <el-button type="text" @click.stop="() => resetNode(node, data)">重置</el-button>
                  <el-button type="text" @click.stop="() => removeNode(node, data)">移除</el-button>
                  <span v-if="data.error" class="error">{{ data.error }}</span>
                </div>
              </template>
              <template v-else>
                <div>
                  <el-tag type="success">名称：{{ data.label }}</el-tag>
                  <el-tag style="margin-left: 10px;">标识：{{ data.value }}</el-tag>
                </div>
                <div class="cascader-data-manage-config-tree-node-ctrl">
                  <el-button type="text" @click.stop="() => editNode(node, data)">编辑</el-button>
                  <el-button type="text" @click.stop="() => appendNode(node, data)">添加子项</el-button>
                  <el-button type="text" @click.stop="() => removeNode(node, data)">删除</el-button>
                </div>
              </template>
            </div>
          </el-tree>
        </div>
      </div>
      <template slot="footer">
        <el-button type="primary" @click="saveJson" :loading="submitLoad">保存</el-button>
        <el-button type="info" @click="showDgmxDetail = false">取消</el-button>
      </template>
    </el-dialog>

    <el-dialog v-if="showJson" title="JSON数据源" :visible.sync="showJson" width="800px" top="15vh"
               :close-on-click-modal="false">
      <el-form ref="jsonFormDom" :model="jsonForm" :rules="jsonRule" label-width="120px">
        <el-form-item prop="json">
          <span slot="label">
            JSON文本
            <el-popover width="300" trigger="hover">
                <i slot="reference" class="el-icon-question" style="color: #286af9" />
                <JsonViewer :value="JSON.parse(tip.replace(/[\n\t]/g, ''))" expanded :expand-depth="10" />
            </el-popover>
          </span>
          <el-input v-model.trim="jsonForm.json"
                    type="textarea"
                    :rows="20"
                    :placeholder="tip"
                    show-word-limit
                    clearable/>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button type="primary" @click="checkJson" :loading="submitLoad">保存</el-button>
        <el-button @click="showJson = false">取消</el-button>
      </template>
    </el-dialog>
  </j-page>
</template>

<script>
import PageMixins from "../../components/JComponents/JPage/mixins/PageMixins";
import PaginationMixins from "../../components/JComponents/JPage/mixins/PaginationMixins";
import DialogMixins from "../../components/JComponents/JPage/mixins/DialogMixins";
import JsonViewer from 'vue-json-viewer';

export default {
  name: "CascaderDataManage",
  mixins: [PageMixins, PaginationMixins, DialogMixins],
  components: { JsonViewer },
  data() {
    return {
      dgmxFormLabelWidth: '80px',
      tip: `[{
      "label":"级联名称",
      "value":"级联标识",
      "children":[{
          "label":"级联名称",
          "value":"级联标识",
          "children":[]
      }]
}]`,
      treeData: [],
      query: {
        cascadingKey: '',
        cascadingTitle: '',
        createTimeStart: '',
        createTimeEnd: ''
      },
      dgmxForm: {
        cascadingTitle: '',
        cascadingKey: '',
        note: '',
        dictionaryJson: []
      },
      dgmxRule: {
        cascadingTitle: [{ required: true, message: '请输入级联名称', trigger: 'blur' }],
        cascadingKey: [{ required: true, message: '请输入级联Key', trigger: 'blur' }]
      },
      showJson: false,
      jsonForm: {
        json: ''
      },
      jsonRule: {
        json: [{required: true, validator: this.jsonValidator, trigger: 'blur'}],
      }
    }
  },
  watch: {
    showJson (nv) {
      if (!nv) {
        this.jsonForm = { ...this.$options.data().jsonForm }
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    scrollTo (data) {
      const id = `${data.label}-${data.value}-${data.edit}`
      this.$nextTick(() => {
        setTimeout(() => {
          document.getElementById(id) && document.getElementById(id).scrollIntoView({ behavior: 'smooth' })
        }, 300)
      })
    },
    notEdit (node) {
      return !node.data.edit
    },
    async detailDgmxEvent (row) {
      this.dgmxType = 'DET'
      this.curItem = { ...row }
      this.treeData = await this.getTreeById(row.id)
      this.showDgmxDetail = true
    },
    async getTreeById (id) {
      const { data } = await this.$http.get(`/api/cascadingDictionarys/${id}`)
      return data.data.dictionaryJson
    },
    async load () {
      this.tableLoading = true
      const { data } = await this.$http.get(`/api/cascadingDictionarys/page`, {
        params: this.query
      }).finally(() => {
        this.tableLoading = false
      })
      if (data.status !== 'yes') return this.$message.warning(data.msg || data.message || `接口异常`)
      this.tableData = data.data.data
      this.query.total = data.data.total
      this.tableLoading = false
    },
    jsonValidator(rule, value, callback) {
      let json = ''
      if (!value && rule.required) {
        return callback(new Error('请输入JSON文本'))
      }
      if (value) {
        try {
          json = JSON.parse(value)
          if (!Array.isArray(json)) {
            return callback(new Error('JSON最外层必须是数组'))
          }
          if (json.length === 0) {
            return callback(new Error('JSON必须是非空数组'))
          }
        } catch (e) {
          console.error(e)
          return callback(new Error('请输入合法的JSON文本'))
        }
      }
      callback()
    },
    handleJsonNode (jsonStr) {
      return jsonStr.replace('[]', 'null')
    },
    checkJson() {
      this.$refs['jsonFormDom'].validate((valid) => {
        if (valid) {
          this.treeData.push(...JSON.parse(this.handleJsonNode(this.jsonForm.json)))
          this.showJson = false
        }
      })
    },
    saveNode(node, data) {
      if (data.label === "") return this.$set(data, 'error', '节点名称不能为空')
      if (data.tempValue === "") return this.$set(data, 'error', '节点标识不能为空')
      if (this.checkNodeRepeat(node.parent.childNodes, data)) return this.$set(data, 'error', '节点标识不能重复')
      data.value = data.tempValue
      data.edit = false
    },
    resetNode(node, data) {
      data.label = ''
      data.value = ''
      data.tempValue = ''
    },
    editNode(node, data) {
      this.$set(data, 'edit', true);
      this.$set(data, 'tempValue', data.value);
    },
    appendRootNode() {
      const newChild = {value: Date.now(), label: '', error: '', children: null, edit: true};
      newChild.tempValue = this.treeData.length + 1
      this.treeData.push(newChild)
      this.scrollTo(newChild)
    },
    appendNode(node, data) {
      const newChild = {value: Date.now(), label: '', error: '', children: null, edit: true};
      newChild.tempValue = node.childNodes.length + 1
      if (!data.children) {
        this.$set(data, 'children', []);
      }
      data.children.push(newChild);
      node.expanded = true
      this.scrollTo(newChild)
    },
    removeNode(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d.value === data.value);
      children.splice(index, 1);
    },
    checkNodeRepeat(parent, data, key = 'tempValue') {
      let flag = false
      parent.some(node => {
        if (data !== node.data && data[key] == node.data.value)
          flag = true
        return flag
      })
      return flag
    },
    processTreeData(nodes) {
      if (!Array.isArray(nodes)) return null;

      return nodes
          .filter(node => node.edit !== true) // 过滤掉edit为true的节点
          .map(node => {
            // 创建新对象，只保留需要的属性
            const newNode = {
              label: node.label,
              value: node.value
            };

            // 处理children
            if (node.children && node.children.length > 0) {
              const processedChildren = this.processTreeData(node.children);
              newNode.children = processedChildren.length > 0 ? processedChildren : null;
            } else {
              newNode.children = null;
            }

            return newNode;
          });
    },
    async saveJson () {
      if (this.submitLoad) return
      this.submitLoad = true
      const dictionaryJson = this.processTreeData(this.treeData)
      let method = 'put'
      let url = `/api/cascadingDictionarys/updateJson/${this.curItem.id}`
      const { data } = await this.$http[method](url, { dictionaryJson })
          .catch(({response}) => { this.$message.error(response.data.msg) })
          .finally(() => { this.submitLoad = false })
      if (data.status !== 'yes') return this.$message.error(data.msg)
      this.showDgmxDetail = false
      this.$message.success('提交成功')
    },
    async saveDgmxData () {
      if (this.submitLoad) return
      this.submitLoad = true
      let method = 'post'
      let url = `/api/cascadingDictionarys`
      if (this.dgmxType === 'EDIT') {
        url = `/api/cascadingDictionarys/${this.curItem.id}`
        method = 'put'
      }
      const { data } = await this.$http[method](url, this.dgmxForm)
          .catch(({response}) => { this.$message.error(response.data.msg) })
          .finally(() => { this.submitLoad = false })
      if (data.status !== 'yes') return this.$message.error(data.msg)
      this.showDgmx = false
      this.$message.success('提交成功')
      this.load()
    },
    delEvent (row) {
      this.$confirm('您确认要删除当前记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.request({ method: 'delete', url: `/api/cascadingDictionarys/${row.id}`})
            .then((res) => {
              if (res.data.status !== 'yes') return this.$message.error(res.data.msg)
              this.pageUpdate(this.query)
              this.$message.success('删除成功')
              this.load && this.load()
            })
      })
    },
    updateCache () {
      this.$confirm('您确认要更新缓存吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.request({ method: 'get', url: `/api/cascadingDictionarys/flush-cascading-dictionary-time`})
            .then((res) => {
              if (res.data.status !== 'yes') return this.$message.error(res.data.msg)
              this.$message.success('更新成功')
            })
      })
    }
  }
}
</script>

<style lang="scss">
.cascader-data-manage-config-dialog {
  .el-tag {
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .el-tree-node__content {
    height: 42px !important;
  }

  .cascader-data-manage-config-dialog-tree {
    max-height: 400px;
    overflow-y: scroll;
  }

  .cascader-data-manage-config-tree-node {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;

    .cascader-data-manage-config-tree-node-form {
      display: flex;
      align-items: center;
      gap: 10px;

      .error {
        font-size: 12px;
        color: #F56C6C;
      }

      .el-button + .el-button {
        margin: 0;
      }
    }

    .cascader-data-manage-config-tree-node-ctrl {
      position: absolute;
      right: 0;
      background: #fff;
    }

    .cascader-data-manage-config-tree-node-input {
      width: 90px;

      .el-input__inner {
        border-color: #286af9;
      }

      &.name {
        width: 120px;

        .el-input__inner {
          border-color: #67c23a;
        }
      }
    }
  }
}
</style>
